import { Col, Row, Table } from 'antd'
import React from 'react'
import logo from '../../assets/logo.png'
import './ExpensePrint.css'
import moment from 'moment'


export const PrintExpense = React.forwardRef((props, ref) => {
    const columns=[
        {
            title:'Name',
            dataIndex:'description'
        },
        
        {
            title:'Details',
            dataIndex:'amount'
        }
    ]

    const data=[
        {
            key:'1',
            description: 'Expense Code',
            amount:`${props.expenseCode}`
        },
        {
          key:'2',
          description:"Date",
          quantity:'',
          amount:`${props.date}`  
        },
        {
            key:'3',
            description: 'Category',
            amount:`${props.category}`
        },
        {
            key:'4',
            description: 'Amount',
            amount:`${props.amount}`
        },
        {
            key:'5',
            description: 'Description',
            amount:`${props.description}`
        }


    ]
    return(
        <div ref={ref} className="print">
        <Row>
            <Col span={12}>
                <p style={{paddingTop:'20px'}}><b>Expense Type: </b> {props.expenseType}</p>
                <p><b>Printed Date: </b>{moment().format('DD-MM-YYYY')}</p>
            </Col>
        <Col span={12}>
                    <img src={logo} className="plogo"/>
                </Col>
                <Col span={24}>
                <Table 
                    columns={columns}
                    dataSource={data}
                    className="table table-bordered"
                    style={{background:'none'}}
                    pagination={false}
                />
                </Col>
        </Row>
        </div>
    )
})
